import { useRef, useEffect } from 'react';
import { typesetKatex } from '@utils/common';
import { heading } from './atom.task-heading.style.js';
import { jsx } from 'react/jsx-runtime';

function TaskHeading(props) {
  const ref = useRef(null);
  useEffect(() => {
    typesetKatex(ref);
  }, []);
  return /*#__PURE__*/jsx("b", {
    ref: ref,
    className: heading,
    children: props.task.title || `Trin ${props.index + 1}`
  });
}

export { TaskHeading };
//# sourceMappingURL=atom.task-heading.js.map
